<template>
  <div class="verification_confirm_wrapper w-full text-center my-2">
    <button
      class="m-auto bg-green-600"
      id="'modal_verification"
      @click="showModal('confirm-verification')"
    >
      Ready To Confirm Your Pattern? <i aria-hidden="true" class="material-icons align-middle">check</i>
    </button>
    <card-modal ref="modal_confirm-verification" >
      <slot></slot>
    </card-modal>
  </div>
</template>

<script>
export default {
  props: {
      array: '',
      route: '',
      demo:'',
  },
  data () {
    return {
    }
  },
  methods: {
    showModal(ID) {
      let modal_id = "modal_" + ID;
      this.$refs[modal_id].show();
    },
  }
};
</script>
